(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = document.querySelector(button.getAttribute('data-menu-toggle'));
        if (!target) return;
        var open = target.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.querySelectorAll('[data-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.faq-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!input) return;
          var step = button.dataset.qtyAction === 'plus' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var val = parseInt(input.value || min, 10) + step;
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.querySelector('[data-gallery-main]');
        var img = thumb.querySelector('img');
        if (!main || !img) return;
        main.innerHTML = '<img src="' + img.src + '" alt="' + (img.alt || '') + '">';
      });
    });
  });
})();
